const { useMemo, useCallback } = require('react');
const { useModuleContext } = require('../context/ModuleContext');

const useNativeEvents = () => {
    const { name: moduleName = 'consumer' } = useModuleContext() || {};

    const appIdentifier = useMemo(() => `${process.env.REMOTE_MODULE_APP_NAME}-${moduleName}`, [moduleName]);
    const addEventListener = useCallback((target, type, listener, options) => target.addEventListener(type, listener, {
        ...options, metadata: {
            timestamp: new Date().getTime(),
            listenerIdentifier: appIdentifier,
        },
    }), [appIdentifier]);

    const removeEventListener = useCallback((target, type, listener, options) => target.removeEventListener(type, listener, {
        ...options, metadata: {
            timestamp: new Date().getTime(),
            listenerIdentifier: appIdentifier,
        },
    }), [appIdentifier]);

    return {
        addEventListener,
        removeEventListener,
        appIdentifier,
    };
};

module.exports = useNativeEvents;
